import { useCallback } from 'react';

import { useCopyTextToClipboard } from './useCopyToClipboard';
export type GridValue = string | number | null | undefined;

export function useCopyToExcel(generateGrid: () => GridValue[][]): () => void {
  const copyTextToClipboard = useCopyTextToClipboard();

  const handleCopy = useCallback(() => {
    const grid = generateGrid();
    const gridInExcelFormat = grid.map(row => row.join('\t')).join('\n');
    copyTextToClipboard(gridInExcelFormat);
  }, [generateGrid, copyTextToClipboard]);

  return handleCopy;
}
